import Navbar from '../components/Navbar.jsx';
import virtualTryOnImage from '../assets/VirtualTry-On.png';
import tourismImage from '../assets/Tourism.png';
import ecommerceImage from '../assets/eCommerce.png';
import aiResearchImage from '../assets/AI Research.png';

const HomePage = () => {
  const models = [
    {
      _id: 'virtual-try-on',
      name: 'Virtual Try-On for Fashion & Clothing Industry',
      category: 'Fashion & Clothing ',
      image: virtualTryOnImage,
      price: 'Enterprise',
      amount: '2999.99',
      description: 'Try Before You Buy — Instantly, Virtually. Transform shopping with AI-powered virtual fitting rooms that boost confidence'
    },
    {
      _id: 'pms-hospitality',
      name: 'Property Management System (PMS) – Tourism & Hospitality',
      category: 'Tourism & Hospitality',
      image: tourismImage,
      price: 'Subscription',
      amount: '1999.99',
      description: 'Automate operations, personalize guest experiences, and maximize revenue with intelligent hospitality management.'
    },
    {
      _id: 'ecommerce-ai',
      name: 'eCommerce Platform (Consumer Retail)',
      category: 'Consumer Retail',
      image: ecommerceImage,
      price: 'Custom',
      amount: '2499.99',
      description: 'Boost conversions with personalized shopping experiences powered by advanced AI intelligence.'
    },
    {
      _id: 'ai-research-dev',
      name: 'AI Research & Development',
      category: 'JOFFON R&D',
      image: aiResearchImage,
      price: 'Open Access',
      amount: '4999.99',
      description: 'Empower your R&D teams with AI tools that speed up discovery, testing, and product development.'
    }
  ];

  return (
    <div className="min-h-screen text-white selection:bg-fuchsia-500/30 bg-[#04050c]">
      <Navbar />

      <div className="relative overflow-hidden border-b border-cyan-500/20 bg-gradient-to-b from-[#0a0f21] via-[#060713] to-[#04050c]">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[820px] h-[420px] bg-cyan-500/20 blur-[130px] rounded-full pointer-events-none animate-pulseSoft"></div>
        <div className="absolute -top-[180px] -right-[160px] w-[540px] h-[540px] bg-fuchsia-500/20 blur-[140px] rounded-full pointer-events-none"></div>
        <div className="absolute -bottom-[210px] -left-[180px] w-[520px] h-[520px] bg-pink-500/20 blur-[150px] rounded-full pointer-events-none"></div>
        
        <div className="max-w-7xl mx-auto py-20 px-4 sm:py-32 sm:px-6 lg:px-8 flex flex-col items-center text-center relative z-10">
          <div className="inline-block rounded-full px-4 py-1.5 text-xs font-semibold tracking-widest mb-6 cyber-glass cyber-glow text-cyan-300">
            JOFFON RESEARCH DIVISION
          </div>
          <h1 className="text-5xl font-extrabold tracking-tight text-white sm:text-6xl md:text-7xl drop-shadow-2xl cyber-text">
            <span className="block">Pioneering the</span>
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 via-fuchsia-300 to-pink-300 mt-2 drop-shadow-[0_0_18px_rgba(236,72,153,0.6)]">Future of Intelligence.</span>
          </h1>
          <p className="mt-6 max-w-2xl mx-auto text-xl text-slate-300/85 font-light">
            We build state-of-the-art artificial intelligence models to solve the world's most complex challenges.
          </p>

        </div>
      </div>

      <main id="technologies" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10">
        <div className="flex justify-between items-end mb-12 border-b border-fuchsia-400/20 pb-4">
          <h2 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-200 via-fuchsia-200 to-pink-200 tracking-tight uppercase cyber-text">Core Technologies</h2>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 mb-32">
          {models.map((model, index) => (
             <div 
               key={model._id} 
               className="group relative rounded-2xl overflow-hidden cyber-glass border border-white/10 hover:border-cyan-300/40 transition-all duration-300 ease-in-out hover:-translate-y-2 hover:shadow-[0_0_28px_rgba(34,211,238,0.35)] flex flex-col h-full animate-floatY"
               style={{ animationDelay: `${index * 120}ms` }}
             >
                <div className="flex flex-col h-full w-full relative z-10">
                  <div className="aspect-w-4 aspect-h-3 bg-[#0a0c19] overflow-hidden relative">
                    <div className="absolute inset-0 bg-gradient-to-t from-[#05070f] via-transparent to-transparent opacity-100 z-10 pointer-events-none"></div>
                    <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/20 via-fuchsia-500/15 to-pink-500/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out z-10 mix-blend-screen pointer-events-none"></div>
                    
                    <img
                      src={model.image}
                      alt={model.name}
                      className="w-full h-48 object-center object-cover opacity-100 group-hover:scale-110 transition-all duration-500 ease-in-out"
                    />
                  </div>
                  <div className="p-6 flex flex-col flex-grow relative bg-gradient-to-b from-[#101327]/60 to-[#070913]/80">
                    <p className="text-xs text-cyan-300 uppercase tracking-widest mb-3 font-semibold drop-shadow-[0_0_10px_rgba(34,211,238,0.65)]">{model.category}</p>
                    <h3 className="text-lg font-bold text-white mb-3 group-hover:text-fuchsia-200 transition-colors duration-300 ease-in-out leading-tight min-h-[3.5rem]">
                      {model.name}
                    </h3>
                    <p className="text-slate-300/80 text-xs mb-6 line-clamp-4 flex-grow leading-relaxed font-light">
                      {model.description}
                    </p>
                  </div>
                </div>
             </div>
          ))}
        </div>

        <div className="relative rounded-3xl p-8 md:p-14 overflow-hidden cyber-glass border border-white/10 shadow-[0_0_40px_rgba(217,70,239,0.16)]">
          <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
          
          <div className="max-w-5xl relative z-10">
            <h2 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-200 via-fuchsia-200 to-pink-200 mb-10 tracking-tight cyber-text">WHY CHOOSE JOFFON?</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-18">
              <div className="group p-6 rounded-2xl cyber-glass border border-white/10 hover:border-cyan-300/35 transition-all duration-300 ease-in-out hover:-translate-y-2 hover:shadow-[0_0_24px_rgba(34,211,238,0.28)]">
                <div className="w-10 h-10 rounded-full bg-cyan-500/15 flex items-center justify-center mb-4 group-hover:bg-cyan-400/20 transition-all duration-300 ease-in-out border border-cyan-300/30">
                  <div className="h-2.5 w-2.5 rounded-full bg-cyan-300 shadow-[0_0_14px_rgba(34,211,238,1)] group-hover:scale-110 transition-transform duration-300 ease-in-out"></div>
                </div>
                <h4 className="text-lg font-bold text-slate-100 uppercase tracking-wide mb-2">Innovation-Driven</h4>
                <p className="text-slate-300/80 text-sm leading-relaxed font-light">We embrace the latest trends and technologies to provide forward-thinking solutions that redefine industry standards.</p>
              </div>

              <div className="group p-6 rounded-2xl cyber-glass border border-white/10 hover:border-fuchsia-300/35 transition-all duration-300 ease-in-out hover:-translate-y-2 hover:shadow-[0_0_24px_rgba(217,70,239,0.28)]">
                <div className="w-10 h-10 rounded-full bg-fuchsia-500/15 flex items-center justify-center mb-4 group-hover:bg-fuchsia-400/20 transition-all duration-300 ease-in-out border border-fuchsia-300/30">
                  <div className="h-2.5 w-2.5 rounded-full bg-fuchsia-300 shadow-[0_0_14px_rgba(217,70,239,1)] group-hover:scale-110 transition-transform duration-300 ease-in-out"></div>
                </div>
                <h4 className="text-lg font-bold text-slate-100 uppercase tracking-wide mb-2">Customer-Centric</h4>
                <p className="text-slate-300/80 text-sm leading-relaxed font-light">Our customers are at the heart of everything we do, and we strive to exceed their expectations in every interaction.</p>
              </div>

              <div className="group p-6 rounded-2xl cyber-glass border border-white/10 hover:border-pink-300/35 transition-all duration-300 ease-in-out hover:-translate-y-2 hover:shadow-[0_0_24px_rgba(236,72,153,0.3)]">
                <div className="w-10 h-10 rounded-full bg-pink-500/15 flex items-center justify-center mb-4 group-hover:bg-pink-400/20 transition-all duration-300 ease-in-out border border-pink-300/30">
                  <div className="h-2.5 w-2.5 rounded-full bg-pink-300 shadow-[0_0_14px_rgba(236,72,153,1)] group-hover:scale-110 transition-transform duration-300 ease-in-out"></div>
                </div>
                <h4 className="text-lg font-bold text-slate-100 uppercase tracking-wide mb-2">Expertise Across Industries</h4>
                <p className="text-slate-300/80 text-sm leading-relaxed font-light">From retail to technology consulting, our team has the experience and knowledge to drive your business forward with intelligent insights.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 rounded-3xl p-10 md:p-16 flex flex-col items-center text-center relative overflow-hidden border border-cyan-400/25 bg-gradient-to-r from-[#0b1022] via-[#1a1030] to-[#120c25] shadow-[0_0_36px_rgba(34,211,238,0.24)] group">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[430px] h-[220px] bg-fuchsia-500/25 blur-[85px] rounded-full pointer-events-none group-hover:scale-110 transition-transform duration-300 ease-in-out"></div>
          
          <div className="relative z-10">
            <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4 tracking-tight uppercase cyber-text">Ready to Pioneer the Future?</h2>
            <p className="text-slate-200/80 mb-10 max-w-2xl text-sm md:text-base leading-relaxed mx-auto font-light">
              Discover how JOFFON's advanced AI solutions can transform your business. Connect with our research and development team today to discuss your next big project.
            </p>
            <a 
              href="mailto:info@joffon.com" 
              className="inline-flex items-center gap-3 rounded-xl py-4 px-10 text-sm font-bold tracking-widest text-white border border-pink-300/45 bg-gradient-to-r from-cyan-500 via-fuchsia-500 to-pink-500 transition-all duration-300 ease-in-out hover:scale-[1.02] hover:-translate-y-1 hover:shadow-[0_0_40px_rgba(236,72,153,0.65)]"
            >
              <svg className="w-5 h-5 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              CONTACT US : INFO@JOFFON.COM
            </a>
          </div>
        </div>

      </main>

      <footer className="border-t border-fuchsia-500/20 bg-[#04050b] mt-10 py-16">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="text-left">
            <h4 className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-200 via-fuchsia-200 to-pink-200 font-extrabold tracking-widest mb-2 text-lg cyber-text">JOFFON L.L.C.</h4>
            <p className="text-slate-400/70 text-sm font-light">3400 Cottage Way, Ste G2 #18859</p>
            <p className="text-slate-400/70 text-sm font-light">Sacramento, California 95825</p>
          </div>
          <div className="text-center md:text-right">
            <p className="text-slate-300/80 text-sm mb-1 font-light hover:text-cyan-300 transition-colors duration-300 ease-in-out cursor-pointer">Email: info@joffon.com</p>
            <p className="text-slate-300/80 text-sm mb-6 font-light">Phone: 925-482-6198</p>
            <p className="text-slate-500 text-[10px] uppercase tracking-[0.2em] font-bold">
              &copy; {new Date().getFullYear()} JOFFON AI. All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;